import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.regexp.replace";
import _Map from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/map";
//====================== Map Fn =========================
var routerTempHelpers = new _Map(); //====================== Back Press Class ===============

export default {
  initial: function initial() {},
  getKey: function getKey() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0;
      var v = c === "x" ? r : r & 0x3 | 0x8;
      return v.toString(16);
    }).toUpperCase();
  },
  setQueryTemp: function setQueryTemp(queryData) {
    var tempKey = this.getKey();
    this.addTemp({
      key: tempKey,
      data: queryData
    });
    return tempKey;
  },
  getQueryTemp: function getQueryTemp(routerQuery) {
    if (routerQuery.tempKey && this.getTemp(routerQuery.tempKey)) {
      return this.getTemp(routerQuery.tempKey);
    } else {
      return null;
    }
  },
  destroyTempQuery: function destroyTempQuery(routerQuery) {
    if (routerQuery.tempKey) {
      this.destroyTemp(routerQuery.tempKey);
    }
  },
  addTemp: function addTemp(temp) {
    var key = temp.key,
        data = temp.data;
    routerTempHelpers.set(key, data); // console.log("listen routerTempHelpers:", routerTempHelpers);
  },
  getTemp: function getTemp(key) {
    if (routerTempHelpers.has(key)) {
      return routerTempHelpers.get(key);
    } else {
      return null;
    }
  },
  destroyTemp: function destroyTemp(key) {
    routerTempHelpers.has(key) ? routerTempHelpers.delete(key) : void 0; // console.log("destroy routerTempHelpers:", {
    //   key,
    //   routerTempHelpers
    // });
  }
};